"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullTableSelectorVisualizer = void 0;
var tslib_1 = require("tslib");
var layout_position_creator_1 = require("../../../core/layout-engine/layout-position-creator");
var layout_change_base_1 = require("../../../core/layout-formatter/changes/changes/layout-change-base");
var document_layout_details_level_1 = require("../../../core/layout/document-layout-details-level");
var point_1 = require("@devexpress/utils/lib/geometry/point");
var rectangle_1 = require("@devexpress/utils/lib/geometry/rectangle");
var size_1 = require("@devexpress/utils/lib/geometry/size");
var drag_caret_listener_1 = require("../../canvas/listeners/drag-caret-listener");
var base_visualizer_1 = require("./base-visualizer");
var FullTableSelectorVisualizer = (function (_super) {
    tslib_1.__extends(FullTableSelectorVisualizer, _super);
    function FullTableSelectorVisualizer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FullTableSelectorVisualizer.prototype.NotifyPagesReady = function (pageChanges) {
        for (var _i = 0, pageChanges_1 = pageChanges; _i < pageChanges_1.length; _i++) {
            var c = pageChanges_1[_i];
            if (c.changeType == layout_change_base_1.LayoutChangeType.Deleted)
                continue;
            this.NotifySelectionChanged(this.control.selection);
            break;
        }
    };
    FullTableSelectorVisualizer.prototype.NotifyFullyFormatted = function (_pageCount) { };
    ;
    FullTableSelectorVisualizer.prototype.NotifySelectionChanged = function (selection) {
        var tableInfo = selection.tableInfo;
        if (tableInfo.extendedData.numRows) {
            var sd = selection.activeSubDocument;
            var tbl = sd.tables[tableInfo.table.index];
            if (tbl) {
                var tblPos = tbl.getStartPosition();
                var lp = (sd.isMain() ?
                    new layout_position_creator_1.LayoutPositionMainSubDocumentCreator(this.control.layout, sd, tblPos, document_layout_details_level_1.DocumentLayoutDetailsLevel.Row) :
                    new layout_position_creator_1.LayoutPositionOtherSubDocumentCreator(this.control.layout, sd, tblPos, this.control.selection.pageIndex, document_layout_details_level_1.DocumentLayoutDetailsLevel.Row))
                    .create(new layout_position_creator_1.LayoutPositionCreatorConflictFlags().setDefault(false), new layout_position_creator_1.LayoutPositionCreatorConflictFlags().setDefault(false));
                if (lp && lp.row.tableCellInfo) {
                    this.pageIndex = lp.pageIndex;
                    var r = lp.row.tableCellInfo.parentRow.parentTable.createRectangle();
                    r.setPosition(new point_1.Point(lp.getLayoutX(null, document_layout_details_level_1.DocumentLayoutDetailsLevel.Column) + r.x - FullTableSelectorVisualizer.OFFSET, lp.getLayoutY(document_layout_details_level_1.DocumentLayoutDetailsLevel.Column) + r.y - FullTableSelectorVisualizer.OFFSET));
                    r.setSize(new size_1.Size(FullTableSelectorVisualizer.SIZE, FullTableSelectorVisualizer.SIZE));
                    this.bounds = r;
                    this.raiseShow();
                    return;
                }
            }
        }
        this.raiseHide();
    };
    FullTableSelectorVisualizer.prototype.show = function (htr) {
        var pageIndex = htr.pageIndex;
        var bounds = new rectangle_1.Rectangle(htr.getLayoutX(this.control.measurer, document_layout_details_level_1.DocumentLayoutDetailsLevel.Character), htr.getLayoutY(document_layout_details_level_1.DocumentLayoutDetailsLevel.Row), drag_caret_listener_1.DragCaretListener.CARET_WIDTH, htr.row.height - htr.row.getSpacingBefore());
        if (!this.bounds || this.pageIndex != pageIndex || !bounds.equals(this.bounds)) {
            this.pageIndex = pageIndex;
            this.bounds = bounds;
            this.raiseShow();
        }
    };
    FullTableSelectorVisualizer.SIZE = 12;
    FullTableSelectorVisualizer.OFFSET = FullTableSelectorVisualizer.SIZE;
    return FullTableSelectorVisualizer;
}(base_visualizer_1.BaseVisualizer));
exports.FullTableSelectorVisualizer = FullTableSelectorVisualizer;
